let get_editTask = function() {
	if (Object.keys(this.get_editTask).length > 0) {
		this.dashEditTask(this.get_editTask);
	}
};
export default get_editTask;
